<template>
    <Dispatch_date-component>
        <div class="p-2">
            <b-row>
                <b-col md="3">
                    <b-form-group label="From Date:"  :label-cols="3" >
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates='{ start: null, end: new Date() }'
                        v-model='selectDate' :input-props="{ readonly: true }">
                        </v-date-picker>
                    </b-form-group>
                </b-col>

                <b-col md="3">
                    <b-form-group label="To Date:"  :label-cols="3" >
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates='{ start: null, end: new Date() }'
                        v-model='toselectDate' :input-props="{ readonly: true }">
                        </v-date-picker>
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <div id='container'>
                        <b-form-group label="Hub Name:" :label-cols="3">
                            <div id='container'>
                                <ejs-multiselect  id='multi_select2'  placeholder="Select Hub Name" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                ></ejs-multiselect>
                            </div>
                        </b-form-group>
                    </div>
                </b-col>
                <b-col md="4">
                    <b-form-group  label="Employee Name:" :label-cols="3" class="mb-4">
                        <v-select v-model="selected_employee" @input="selectsearchemployee(selected_employee)" :options="employeelist" placeholder="-- Select Employee NO --"></v-select>
                    </b-form-group>
                </b-col>

                <!-- <b-col md="8"></b-col> -->

                <b-col md="4">
                    <b-button variant="primary" @click="EmployeeList(pageNum)"> Search </b-button>&nbsp;
                    <b-button variant="danger" @click="clear()"> Clear </b-button>&nbsp;
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" class="text-right">
                    <p > <b>Total Records :<span style="color:red;">{{totalUserRows}}</span></b> </p>
                 </b-col>
            </b-row>
            
            <div>
                <ul v-for="empitems in employeeitems" class="" style="border: 1px solid black;background-color: rgb(198, 241, 200);" >
                    <b-row>
                        <b-col md="2"  style="border-right: 1px solid black;text-align: center;"  @click="openImgModal(empitems.faceIdValue)">
                            <img class="" :src="empitems.faceIdValue" width="100" height="100" alt="Custom Marker Icon"  />
                        </b-col>
                        <b-col md="10">
                            <b-row md="2" class="rowclass">
                                <b-button variant="primary" class="btnclass"> {{ empitems.name }} </b-button>&nbsp;
                                <b-button  variant="success" style="color: #fff;" class="btnclass"> {{ empitems.status }} </b-button>&nbsp;
                            </b-row>
                            <!-- <b-row md="5" class="rowclass" v-if="empitems.status != 'rejected' && empitems.status != 'approved'">
                              Face Registration request has been raised by {{ empitems.createdby }} ({{ empitems.employeeid }}) om {{ empitems.createdat }} from {{ empitems.name }}  and is awaiting for action.
                            </b-row> -->
                            <b-row md="5" style="margin-right: 0px !important;" class="rowclass" v-if="empitems.status == 'approved'">
                            Face Registration request raised by {{ empitems.createdby }} ({{ empitems.employeeid }}) from {{ empitems.name }} on {{ empitems.createdat }}, is now approved by {{ empitems.userapproved_rejectedby ? empitems.userapproved_rejectedby : '' }} on {{ empitems.approved_rejectedon ? empitems.approved_rejectedon : '' }}
.
                            </b-row>

                            {{ empitems.userapproved_rejectedby ? empitems.userapproved_rejectedby : '' }}
                            <!-- <b-row md="5" class="rowclass" v-if="empitems.status == 'rejected'">
                            Face Registration request raised by {{ empitems.createdby }} ({{ empitems.employeeid }}) from {{ empitems.name }} on {{ empitems.createdat }} has been rejected by {{ empitems.updatedby }} on {{ empitems.updatedat }}.
                            </b-row> -->

                            <b-row md="3" class="rowclass">
                                <span style="font-weight: bold;" v-if="empitems.status == 'rejected' || empitems.status == 'approved'"> 
                                     {{ empitems.approved_rejectedon ? empitems.approved_rejectedon : '' }}
                                </span>
                            
                               <span style="margin-left: 67%;"  v-if="empitems.status == 'approved'">
                                    <b-button variant="primary" class="btnclass" @click="openApprovedViewDetailsModal(empitems)"> View Details </b-button>&nbsp;
                               </span>
                
                            </b-row>
                        </b-col>
                    </b-row>
                </ul>
                <ul>
                    <b-row>
                        <b-col v-if="totalUserRows>20">
                            <paginate 
                            :page-count="pinnoofpages"
                            :page-range="10"
                            :margin-pages="2"
                            :click-handler="pinclickCallback"
                            :prev-text="'Prev'"
                            :next-text="'Next'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                            </paginate>
                    
                        </b-col> 
                    </b-row>
                </ul>
              
           </div>
          
             <b-modal
                        id="imgview"
                        size="xl"
                        title=""
                        v-model="modalOpen"
                        @ok="modalOpen = false"
                        hide-footer>
                        <div class = "imgclass-2">
                            <img :src="viewImg" class="modal-img" alt="Custom Marker Icon" />
                        </div>
             </b-modal>

            <b-modal
                        id="imgview"
                        size="xl"
                        title="Emp Details:"
                        v-model="ApprovedViewDetailModalOpen"
                        @ok="ApprovedViewDetailModalOpen = false"
                        hide-footer>
                        <div class = "detailsclass">
                        <b-row>
                            <b-col md="6">
                                <label>Request Raised by,</label><br><br>

                                <label>Emp Name:  <span>{{empdetails.username}} {{empdetails.lastname}}</span></label><br>
                                <label>Emp Email:  <span>{{empdetails.createdby}}</span></label><br>
                                <label>Emp Id: {{empdetails.employeeid}}</label><br>
                                <label>Mob No: {{empdetails.contactnumber}}</label><br>
                                <label>Face Id: <img style="border: 1px solid black;"  :src="empdetails.faceIdValue"  width="110" height="110" alt="Custom Marker Icon" /></label><br>
                                <label>Hub Name: {{empdetails.name}}</label><br>
                                <label>Request Date & Time: {{empdetails.createdat}}</label><br>
                            </b-col>
                            <b-col md="6">
                                <label>Request Approved by,</label><br><br>

                                <label>Reporting Manager Name:  <span>{{approverejectdetails.userfirstname}} {{approverejectdetails.userlastname}}</span></label><br>
                                <label>Reporting Manager Email:  <span>{{approverejectdetails.sysemailid}}</span></label><br>
                                <label>Reporting Manager Id: {{approverejectdetails.empid}}</label><br>
                                <label>Approved Date & Time: {{empdetails.updatedat}}</label><br>
                            </b-col>
                        </b-row>
                        

                        </div>
            </b-modal>
         
            <!-- <b-modal size="lg" title="View Log Details" v-model="loaddetailsmodel" @ok="loaddetailsmodel=false"
            hide-footer>
            <b-row>
                <b-col sm="12" class="text-right">
                    <p > <b>Total Records :<span style="color:red;">{{totalUserRows}}</span></b> </p>
                 </b-col>
            </b-row>

            </b-modal> -->
        </div>
    </Dispatch_date-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
export default {
//     components: {
//     Modal
//   },
    data() {
        return {
            selectDate : new Date(),
            toselectDate : new Date(),
            modalOpen: false,
            ViewDetailModalOpen: false,
            RejectedViewDetailModalOpen: false,
            ApprovedViewDetailModalOpen: false,
            items: [],
            totalRows :0,
            employeeitems : [],
            empdetails : {},
            approverejectdetails:{},
            employeelist : [],
            selected_employee : '',
            isBusy : false,
            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],
            WHData:[],
            showSelectAll : true,
            loadurl :'',
            LoadDetails:[],
            totalUserRows: 0,
            loadisBusy : false,
            loaddetailsmodel : false,
            pinnoofpages : '',
            pinlistingpageno :1,
            viewImg: '',
            pageNum:1,
            searchingdata : false
           
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
    
        this.displayAllData(this.pageNum);
        this.showWHlist();
        //this.EmployeeList();
        this.showEmplist();
    },

    methods: {
        selectsearchemployee(selected_employee) {
            if(selected_employee==null){
                this.selected_employee="";
                this.displayAllData(this.pageNum);
            }
            console.log("selected_employee : ",selected_employee);
        },
        pinclickCallback(pinpageNum){
            console.log("click back--------->");
            this.pinlistingpageno = pinpageNum;
            if(this.searchingdata)
            {
             this.EmployeeList(pinpageNum);
            }else{
                this.displayAllData(pinpageNum);
            }
        },
        showEmplist: function() {

            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.employeelist=[];
            const deliveryagentobj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                usertype: `${userInfo.user_type}`
            };
            console.log("deliveryagentobj", deliveryagentobj);
            // return false;
            this.$http
            .post(
            `${CONSTANTS.MIGRATION_API_URL}/getEmployeeListing`,
            deliveryagentobj
            )
            .then((result) => {
            console.log("YYY", result);
            if (result.data.returnvalue.length > 0) {
                //this.data = result.body;
                this.employeelist = result.data.returnvalue;
                console.log("vehical items ------------------>",this.employeelist );
                var data = [];

                result.data.returnvalue.forEach(function (srData) {
                    data.push({
                    key:srData.userid,
                    label:srData.username+' '+srData.lastname
                    });
                });
                this.employeelist = data;
                console.log("data ------------------>",data );
            } else {
                //this.data = result.body;
                this.employeelist = [];
            }
            })
            .catch((ex) => {
            console.log("error", ex);
            });
            },
        getuserdata(empdata)
        {
           this.empdetails = empdata;
           this.approverejectdetails = {};

           const empobj = {
                useremailid: `${empdata.userapproved_rejectedby}`
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getUserdetails`, empobj)
            .then((result) => {
            if (result.data.returnvalue.length > 0) 
            {
                this.approverejectdetails = result.data.returnvalue[0];
            } else {
                this.approverejectdetails = {};
            }
            })
            .catch((ex) => {
            console.log("error", ex);
            });
        },
    
        openApprovedViewDetailsModal(empdata)
        {
            console.log("emp data--------->",empdata);
            if(empdata.userapproved_rejectedby){
           this.getuserdata(empdata);
        }
           this.ApprovedViewDetailModalOpen = true;
        },
        openImgModal(Img) {
            this.viewImg = Img;
            this.modalOpen = true;
            },
        displayAllData: function(pagenum) {

            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            var selectDate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";
            var toselectDate = (this.toselectDate!=null)?this.formatDate(this.toselectDate):"";

            this.employeeitems=[];
            const deliveryagentobj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                status:`approved`,
                startdate : selectDate,
                enddate : toselectDate,
                page_no:`${pagenum}`
            };
            this.$http
            .post(
            `${CONSTANTS.MIGRATION_API_URL}/getAllListing`,
            
            deliveryagentobj
            )
            .then((result) => {
            if (result.data.returnvalue.length > 0) {

                this.employeeitems = result.data.returnvalue;
                this.fetchFaceIdData(this.employeeitems);
                this.totalUserRows = result.data.totalcount;

                this.pinnoofpages=parseInt(this.totalUserRows)/2;
                this.pinnoofpages=Math.ceil( this.pinnoofpages);
              
            } else {
                this.employeeitems = [];
            }
            })
            .catch((ex) => {
            console.log("error", ex);
            });
        },
        showWHlist:function(){
          
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`
            };
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubList`, csvObj)
              .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                    this.optionsWH=[];
                
                    this.WHData  = result.body.returnvalue;
                    
                    for(let j = 0; j < this.WHData.length; j++) {
                        let WH = {
                        name: this.WHData[j].hub_title + " - " + this.WHData[j].fcclock_hubid,
                        id: this.WHData[j].fcclock_hubid,
                        }
                    this.optionsWH.push(WH);
                    }
                
                } else {              
                    this.WHData  = result.body.returnvalue;
                }
            
  
            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        EmployeeList : function (pagenum) {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            this.isBusy = true;
            var selectDate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";
            var toselectDate = (this.toselectDate!=null)?this.formatDate(this.toselectDate):"";
       
           var user_id = (this.selected_employee && this.selected_employee !== null && this.selected_employee.key) ? this.selected_employee.key : "";

            var warehouseid=(this.valueWH.length>0)? this.valueWH: [''];
            
            const obj = {
                sysusermasterid:`${userInfo.sysusermasterid}`,
                startdate : selectDate,
                enddate : toselectDate,
                status:`approved`,
                user_id : user_id,
                warehouseid : warehouseid,
                page_no:`${pagenum}`
            }
            console.log("object------------->",obj);
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllListing`,obj)
            .then(result =>{
                this.isBusy = false;
                console.log("resilky 00==>",result);
                if (result.body.returnmsg === "Successful") {
                    this.searchingdata = true;
                    this.employeeitems = result.data.returnvalue;
                    this.fetchFaceIdData(this.employeeitems);
                    this.totalUserRows = result.data.totalcount;

                    this.pinnoofpages=parseInt(this.totalUserRows)/2;
                    this.pinnoofpages=Math.ceil( this.pinnoofpages);
                
                } else {
                    this.employeeitems = [];
                    this.totalUserRows = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        fetchFaceIdData(employees) {
            console.log("empliye--------->");
            const faceIdPromises = employees.map((employee) => {
                return this.$http
                .post(`${CONSTANTS.MIGRATION_API_URL}/getImageUrl`, { faceid: `${employee.faceid}` }) // Assuming employee has an 'id' field
                .then((response) => {
                    console.log("response.data------>",response.data);
                    // You can process the Face ID response as needed
                    var faceId = 'https://cdn-icons-png.flaticon.com/128/63/63820.png';
                    if(response.data.length)
                    {
                        faceId = response.data[0].image;
                    }
                    return { ...employee, faceIdValue: faceId }; // Adjust based on your API response
                })
                .catch((ex) => {
                    console.error(`Error fetching Face ID for employee ${employee.id}`, ex);
                    return { employeeId: employee.id, faceIdValue: 'https://cdn-icons-png.flaticon.com/128/63/63820.png' }; // Handle error case
                });
            });

            Promise.all(faceIdPromises)
                .then((results) => {
                    this.employeeitems = results; // Store all Face ID data
                console.log('Face ID Data:',  this.employeeitems); // Check the results
                })
                .catch((ex) => {
                console.error("Error fetching Face ID data", ex);
                });
            },

        clear(){
            this.selectDate = new Date();
            this.searchingdata = false;
            this.selected_employee = '';
            this.valueWH =[];
            this.showEmplist();
            this.showWHlist();
            this.displayAllData(this.pageNum);
        },

        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },
    },
}
</script>

<style scope>
.Delivery_Dashboard .table thead tr{
    background: #f0f3f5 !important;
    border: 1px solid #c9b9b9 !important
}
.Delivery_Dashboard .table thead tr:hover {
    background: #f0f3f5 !important;
    border: 1px solid #c9b9b9 !important
}
.Delivery_Dashboard .table thead .bordercalls th{
    border: 0px solid rgb(227, 219, 219) !important;
}
.Delivery_Dashboard .table thead tr th, .Delivery_Dashboard .table thead tr td{
    border: 1px solid rgb(221, 208, 208) !important;
}
.Delivery_Dashboard .table thead .bordercalls .totalload{
    border: 1px solid #c9b9b9 !important
}
.btnclass{
    margin-top: 5px;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-bottom: 5px;
}
.imgclass{
    padding-left: 116px;
}
.detailsclass{
    font-weight: bold;
    font-size: medium;
}
.rowclass{
    padding-left: 2%;
}
.img{
    margin-left: 50px;

}
.imgclass-2 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.modal-img {
    width: 600px;   
  height: 600px;   
  object-fit: contain; 
 }
</style>